import moment from "moment";

export const searchUrl = (
	guestsData: any,
	location: any,
	query: any,
	searchInput: any,
	checkin: any,
	checkout: any,
	type: any,
) => {
	if (type === "/search") {
		return `/search?location=${searchInput}&checkin=${
			checkin !== "Invalid date" ? checkin : ""
		}&checkout=${checkout !== "Invalid date" ? checkout : ""}&guests=${
			guestsData.guests
		}&rooms=${guestsData.rooms}&lat=${
			query.get("lat") || location.latitude
		}&lon=${query.get("lon") || location.longitude}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}&unavail=${query.get("unavail") ? query.get("unavail") : ""}`;
	}
	if (type === "villas") {
		return `/villas/villa-in-${searchInput}?checkin=${
			checkin !== "Invalid date" ? checkin : ""
		}&checkout=${checkout !== "Invalid date" ? checkout : ""}&guests=${
			guestsData.guests
		}&rooms=${guestsData.rooms}&lat=${location.latitude}&lon=${
			location.longitude
		}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}&unavail=${query.get("unavail") ? query.get("unavail") : ""}`;
	}
};

export const searchUrlMobileBar = (query: any, type: any) => {
	if (type === "/search") {
		return `/villas/villa-near-me?&checkin=${
			query.get("checkin") ? query.get("checkin") : ""
		}&checkout=${query.get("checkout") ? query.get("checkout") : ""}&guests=${
			query.get("guests") ? query.get("guests") : 1
		}&rooms=${
			query.get("rooms") ? query.get("rooms") : 1
		}&lat=${""}&lon=${""}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&club=${
			query.get("club") ? query.get("club") : ""
		}&signature=${
			query.get("signature") ? query.get("signature") : ""
		}&unavail=${query.get("unavail") ? query.get("unavail") : ""}&sortby=${
			query.get("sortby") ? query.get("sortby") : ""
		}&coupon=${query.get("coupon") ? query.get("coupon") : ""}`;
	}

	if (type === "villas") {
		return `/villas/villa-near-me?&checkin=${
			query.get("checkin") ? query.get("checkin") : ""
		}&checkout=${query.get("checkout") ? query.get("checkout") : ""}&guests=${
			query.get("guests") ? query.get("guests") : 1
		}&rooms=${
			query.get("rooms") ? query.get("rooms") : 1
		}&lat=${""}&lon=${""}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&club=${
			query.get("club") ? query.get("club") : ""
		}&signature=${
			query.get("signature") ? query.get("signature") : ""
		}&unavail=${query.get("unavail") ? query.get("unavail") : ""}&sortby=${
			query.get("sortby") ? query.get("sortby") : ""
		}&coupon=${query.get("coupon") ? query.get("coupon") : ""}`;
	}
	return null;
};

export const searchUrlMobile = (search: any, query: any, type: any) => {
	if (type === "/search") {
		return `/search?location=${search.title}&checkin=${
			query.get("checkin") ? query.get("checkin") : ""
		}&checkout=${query.get("checkout") ? query.get("checkout") : ""}&guests=${
			query.get("guests") ? query.get("guests") : 1
		}&rooms=${query.get("rooms") ? query.get("rooms") : 1}&lat=${
			search.latitude
		}&lon=${search.longitude}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&unavail=${
			query.get("unavail") ? query.get("unavail") : ""
		}&sortby=${query.get("sortby") ? query.get("sortby") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}`;
	}
	if (type === "villas") {
		return `/villas/villas-in-${search.title}?checkin=${
			query.get("checkin") ? query.get("checkin") : ""
		}&checkout=${query.get("checkout") ? query.get("checkout") : ""}&guests=${
			query.get("guests") ? query.get("guests") : 1
		}&rooms=${query.get("rooms") ? query.get("rooms") : 1}&lat=${
			search.latitude
		}&lon=${search.longitude}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&unavail=${
			query.get("unavail") ? query.get("unavail") : ""
		}&sortby=${query.get("sortby") ? query.get("sortby") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}`;
	}
	return null;
};

export const searchUrlCalendar = (query: any, dates: any, type: any) => {
	if (type === "/search") {
		return `/search=${
			query.get("location") ||
			window.location.pathname?.split("/")[2]?.split("-")[2]
		}&checkin=${
			dates.checkin
				? moment(dates.checkin).format("YYYY-MM-DD")
				: moment().add(1, "days").format("YYYY-MM-DD")
		}&checkout=${
			dates.checkout
				? moment(dates.checkout).format("YYYY-MM-DD")
				: moment().add(2, "days").format("YYYY-MM-DD")
		}&guests=${query.get("guests") ? query.get("guests") : 1}&rooms=${
			query.get("rooms") ? query.get("rooms") : 1
		}&lat=${query.get("lat") ? parseFloat(query.get("lat")) : ""}&lon=${
			query.get("lon") ? parseFloat(query.get("lon")) : ""
		}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&unavail=${
			query.get("unavail") ? query.get("unavail") : ""
		}&sortby=${query.get("sortby") ? query.get("sortby") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}`;
	}
	if (type === "villas") {
		return `/villas/villas-in-${
			query.get("location") ||
			window.location.pathname?.split("/")[2]?.split("-")[2]
		}?&checkin=${
			dates.checkin
				? moment(dates.checkin).format("YYYY-MM-DD")
				: moment().add(1, "days").format("YYYY-MM-DD")
		}&checkout=${
			dates.checkout
				? moment(dates.checkout).format("YYYY-MM-DD")
				: moment().add(2, "days").format("YYYY-MM-DD")
		}&guests=${query.get("guests") ? query.get("guests") : 1}&rooms=${
			query.get("rooms") ? query.get("rooms") : 1
		}&lat=${query.get("lat") ? parseFloat(query.get("lat")) : ""}&lon=${
			query.get("lon") ? parseFloat(query.get("lon")) : ""
		}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&unavail=${
			query.get("unavail") ? query.get("unavail") : ""
		}&sortby=${query.get("sortby") ? query.get("sortby") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}`;
	}
};

export const searchUrlGuest = (query: any, data: any, type: any) => {
	if (type === "/search") {
		return `/search=${
			query.get("location") ||
			window.location.pathname?.split("/")[2]?.split("-")[2]
		}?checkin=${query.get("checkin") ? query.get("checkin") : ""}&checkout=${
			query.get("checkout") ? query.get("checkout") : ""
		}&guests=${data.guests}&rooms=${data.rooms}&lat=${query.get(
			"lat",
		)}&lon=${query.get("lon")}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&unavail=${
			query.get("unavail") ? query.get("unavail") : ""
		}&sortby=${query.get("sortby") ? query.get("sortby") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}`;
	}
	if (type === "villas") {
		return `/villas/villas-in-${
			query.get("location") ||
			window.location.pathname?.split("/")[2]?.split("-")[2]
		}?checkin=${query.get("checkin") ? query.get("checkin") : ""}&checkout=${
			query.get("checkout") ? query.get("checkout") : ""
		}&guests=${data.guests}&rooms=${data.rooms}&lat=${query.get(
			"lat",
		)}&lon=${query.get("lon")}&amenities=${
			query.get("amenities") ? query.get("amenities") : ""
		}&events=${query.get("events") ? query.get("events") : ""}&unavail=${
			query.get("unavail") ? query.get("unavail") : ""
		}&sortby=${query.get("sortby") ? query.get("sortby") : ""}&coupon=${
			query.get("coupon") ? query.get("coupon") : ""
		}`;
	}
};

export const collectionUrl = (search: any, pathname: any, query: any) => {
	return `${pathname?.split("-in-")[0]}-in-${search.title}?lat=${
		search.latitude
	}&lon=${search.longitude}&checkin=${
		query?.get("checkin")
			? moment(query?.get("checkin")).format("YYYY/MM/DD")
			: ""
	}&checkout=${
		query?.get("checkout")
			? moment(query?.get("checkout")).format("YYYY/MM/DD")
			: ""
	}`;
};

export const collectionUrlCalendar = (
	query: any,
	dates: any,
	pathname: any,
) => {
	return `${pathname}?lat=${query.get("lat") ? query.get("lat") : ""}&lon=${
		query.get("lon") ? query.get("lon") : ""
	}&checkin=${
		dates.checkin ? moment(dates.checkin).format("YYYY/MM/DD") : ""
	}&checkout=${
		dates.checkout ? moment(dates.checkout).format("YYYY/MM/DD") : ""
	}`;
};
